// components/CircularProgressWithLabel.tsx
import React from 'react';
import { Box, Typography, CircularProgress, CircularProgressProps } from '@mui/material';

interface CircularProgressWithLabelProps extends CircularProgressProps {
  value?: number;
  label?: string;
  size?: number;
  thickness?: number;
}

export const CircularProgressWithLabel: React.FC<CircularProgressWithLabelProps> = ({
  value,
  label,
  size = 40,
  thickness = 4,
  ...props
}) => {  
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      my: 2 
    }}>
      {/* Container for progress and overlay */}
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant={value !== undefined ? "determinate" : "indeterminate"}
          value={value}
          size={size}
          thickness={thickness}
          {...props}
        />
      </Box>
      
      {/* Separate label below progress */}
      {label && value === undefined && (
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ mt: 1, textAlign: 'center' }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default CircularProgressWithLabel;